(() => {
  const SELECTOR = '[data-mds-letter]';

  function initMDSLetter(section) {
    if (!section || section.dataset.mdsLetterReady === 'true') return;

    const openButton = section.querySelector('[data-mds-letter-open]');
    const modal = section.querySelector('[data-mds-letter-modal]');
    const panel = section.querySelector('[data-mds-letter-panel]');
    const closeButtons = section.querySelectorAll('[data-mds-letter-close]');

    if (!openButton || !modal || !panel) return;

    let previousFocus = null;
    let openTimer = null;
    let closeTimer = null;

    const focusableSelector =
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function openLetter() {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);

      previousFocus = document.activeElement;
      openButton.setAttribute('aria-expanded', 'true');
      section.classList.add('is-opening');

      openTimer = window.setTimeout(() => {
        modal.hidden = false;

        requestAnimationFrame(() => {
          modal.classList.add('is-open');
          document.body.classList.add('mds-letter-modal-open');
          document.addEventListener('keydown', onKeydown);

          window.setTimeout(() => {
            panel.focus({ preventScroll: true });
          }, 40);
        });
      }, 360);
    }

    function closeLetter() {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);

      modal.classList.remove('is-open');
      openButton.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown);

      closeTimer = window.setTimeout(() => {
        modal.hidden = true;
        section.classList.remove('is-opening');

        if (!document.querySelector('.mds-letter-modal.is-open')) {
          document.body.classList.remove('mds-letter-modal-open');
        }

        if (previousFocus && typeof previousFocus.focus === 'function') {
          previousFocus.focus({ preventScroll: true });
        }
      }, 280);
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeLetter();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = Array.from(
        modal.querySelectorAll(focusableSelector)
      ).filter((element) => {
        return (
          element.offsetWidth > 0 ||
          element.offsetHeight > 0 ||
          element === document.activeElement
        );
      });

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    openButton.addEventListener('click', openLetter);

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeLetter);
    });

    section.dataset.mdsLetterReady = 'true';
  }

  function initAll(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(initMDSLetter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
